// The pure row-selection rules for the Tools rosters: which rows a view shows,
// and which shell binaries fold into the "other shell" rollup. DOM-free and
// state-free (the caller passes the kind + controls), so the rules that decide
// what a user can and can't see are unit-testable rather than only observable by
// scrolling the page.

export interface RosterRow {
  name: string
  status?: string
  shell?: boolean
  flags?: string[]
}

export var SHELL_TOP_N = 15

export function isToolSelected(raw: string | null | undefined, active: string | null | undefined): boolean {
  return !!raw && !!active && raw === active
}

export interface DetailRequest {
  kind: string
  name: string
  filter?: string | null
  win: string
}

export function detailStillCurrent(sent: DetailRequest, now: DetailRequest): boolean {
  return (
    sent.kind === now.kind &&
    sent.name === now.name &&
    (sent.filter || '') === (now.filter || '') &&
    sent.win === now.win
  )
}

export function filterRows<T extends RosterRow>(rows: T[], kind: string, status: string, search: string): T[] {
  var out = rows
  if (status) out = out.filter((r) => (r.flags || []).indexOf(status) >= 0)
  if (search) {
    var q = search.toLowerCase()
    out = out.filter((r) => r.name.toLowerCase().indexOf(q) >= 0)
  }
  return out
}

export function rollupTail<T extends RosterRow>(rows: T[]): T[] {
  var shell = rows.filter((r) => r.shell)
  if (shell.length <= SHELL_TOP_N) return []
  return shell.slice(SHELL_TOP_N).filter((r) => !(r.flags || []).length)
}
